// ignore-string-externalization

// Shape preserved from Redux store (blog.ts) to avoid changes in consuming components
export const categoriesTemplate = [
  { name: 'All', urlSlug: 'all' },
  { name: 'Products', urlSlug: 'products' },
  { name: 'Best Practices', urlSlug: 'best-practices' },
  { name: 'Stories', urlSlug: 'stories' },
  { name: 'Other', urlSlug: 'other' },
];

export const getEmptyCategoriesState = () => ({
  bySlug: categoriesTemplate.reduce(
    (acum, catgry) =>
      Object.assign(acum, {
        [catgry.urlSlug]: {
          ...catgry,
          items: [] as string[],
          offset: 0,
          total: undefined as number | undefined,
        },
      }),
    {} as Record<
      string,
      {
        name: string;
        urlSlug: string;
        items: string[];
        offset: number;
        total: number | undefined;
      }
    >,
  ),
  nameToSlug: categoriesTemplate.reduce(
    (acum, catgry) => Object.assign(acum, { [catgry.name]: catgry.urlSlug }),
    {} as Record<string, string>,
  ),
  allSlugs: categoriesTemplate.map(item => item.urlSlug),
});
